import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffd2ba76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 rounded-lg bg-secondary space-y-4 border border-primary" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("There are currently no townsfolk available for recruitment.")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Address not found on whitelist. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" You've used up your whitelist credits.")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from "vue";
import { useAuthStore } from "@/stores/authStore";
import MintComponent from "@/components/MintComponent.vue";
import { format } from "date-fns";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const availability = computed(() => useAuthStore().availability);
const canMint = computed(() => {
  const authStore = useAuthStore();
  if (availability.value == "private")
    return authStore.isPrivateMember && authStore.balance > 0;
  if (availability.value == "closed") return false;
  return true;
});

const publicMintTime = format(
  new Date(Number(process.env.VUE_APP_PUBLIC_MINT)),
  "do MMMM yyyy @ HH:mm"
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(availability) == 'closed')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2
        ], 64))
      : (_unref(canMint))
        ? (_openBlock(), _createBlock(MintComponent, { key: 1 }))
        : (_unref(availability) == 'private')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_unref(useAuthStore)().isPrivateMember)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3
                  ], 64))
                : (_unref(useAuthStore)().balance == 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_4
                    ], 64))
                  : _createCommentVNode("", true),
              _hoisted_5,
              _createTextVNode("Public mint is on " + _toDisplayString(_unref(publicMintTime)) + " (your local time) ", 1)
            ], 64))
          : _createCommentVNode("", true)
  ]))
}
}

})